import { MixinTemplate } from '@upright/common/model/input/product-mixins/templates/types';
import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';
import { useQuery } from '@tanstack/react-query';
import { useIsTeam } from '../../../../common/generic/hooks';

export const FETCH_LATEST_MIXIN_TEMPLATES = 'getLatestMixinTemplates';

export function useGetLatestMixinTemplates() {
  const isTeam = useIsTeam();

  return useQuery<MixinTemplate[] | null, Error>({
    queryKey: [FETCH_LATEST_MIXIN_TEMPLATES],
    queryFn: isTeam
      ? async () => await fetchOrThrow<MixinTemplate[]>(`/product-mixin/templates/latest`, 'GET')
      : () => null,
    retry: 3,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    staleTime: 30_000,
    enabled: isTeam,
  });
}
